import React, {useContext, useState} from 'react'
import {SettingRoleContext} from "../../context/SettingRoleContext";
import {Input, message} from 'antd';
import {saveRoleDataLevel} from "../../../../services/api/apiSwagger";
import parseToken from "../../../../helpers/parseToken";
import {CheckCircleOutlined, StopOutlined,} from '@ant-design/icons';

const {TextArea} = Input;

function RolesDataItem(props) {
    const {item, index} = props
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {fetchListRoleData} = SettingRolePageContext
    const [itemEdited, setItemEdited] = useState({dataLevel: '', id: 0})

    const _hadleEditItem = () => {
        setItemEdited({
            dataLevel: item.dataLevel,
            id: item.id
        })
    }

    const _handleChangeItem = (e) => {
        const {value} = e.target
        setItemEdited({
            ...itemEdited,
            dataLevel: value
        })
    }

    const _saveRoleFunction = async () => {
        try {
            const decodeToken = parseToken()
            const response = await saveRoleDataLevel(decodeToken.sub, itemEdited)

            const {success, error_message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            fetchListRoleData()
            setItemEdited({dataLevel: '', id: 0})
            message.success('Lưu dữ liệu thành công!')
        } catch (e) {
            message.error(e.message)
        }
    }

    return (
        <tr className="RowItem">
            <td className="itemCol">
                {index + 1}
            </td>
            <td className="itemCol">{item.dataObject || ''}</td>
            <td className="itemCol">{item.dataAction || ''}</td>
            <td className="itemCol">{item.type || ''}</td>
            <td className="itemCol w-50">{itemEdited.id === item.id ?
                <TextArea rows={5} value={itemEdited.dataLevel || ''}
                          onChange={_handleChangeItem}/> : item.dataLevel || ''}</td>
            <td className="itemCol text-center">{item.status === 1 ?
                <CheckCircleOutlined style={{color: '#39D620', fontSize: '22px'}}/> :
                <StopOutlined style={{color: 'red', fontSize: '22px'}}/>}</td>
            <td className="itemCol Actions">
                {itemEdited.id === item.id ?
                    <span onClick={_saveRoleFunction} className="cursor-pointer material-icons">save</span>
                    : <span onClick={_hadleEditItem} className="cursor-pointer material-icons">border_color</span>}
            </td>
        </tr>
    )
}

export default RolesDataItem
